import { showToast } from 'vant'
import { customEventFn, eventName } from '@/plugins/bi-sa.client'

const linkJump = (href) => {
  window.open(
    href,
    '_blank',
    'toolbar=yes, location=yes, directories=no, status=no, menubar=yes, scrollbars=yes, resizable=no, copyhistory=yes, width=600, height=450,top=100,left=350'
  )
}

export const shareFacebook = (href, title) => {
  linkJump(`http://www.facebook.com/sharer.php?u=${encodeURIComponent(href)}&t=${title}`)


}

export const shareWhatsApp = (href, title) => {
  linkJump(`https://api.whatsapp.com/send?text=${title} ${encodeURIComponent(href)}`)
}

export const shareCopyLink = (url, title) => {
  const inputEl = document.createElement('input')

  inputEl.value = `${title} ${url}`
  inputEl.setAttribute('style', 'opacity: 0;height:0;')
  document.body.appendChild(inputEl)
  inputEl.select()
  document.execCommand('copy')
  showToast('Link has been copied')
  document.body.removeChild(inputEl)
}

// type = wap / android / flutter
export const shareSMS = async(href, title, type='wap') => {
  const u = navigator.userAgent
  const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
  // const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //安卓终端
  let url = `sms:?body=${title} ${href}`
  if (isIOS) {
    // IOS 连接符为 ‘&’
    url = url.replace('?', '&')
  }

  linkJump(url)
}

// type = wap / android / flutter
export const share = async(share, config, shareType = '') => {
  const { href, title, shareContents } = config

  const { $sensors, $SENSORS_EVENT } = useNuxtApp()
  const appShare = JSON.stringify({
    shareLink: href,
    shareTitle: title,
    shareContents,
    visible: 1,
    channel: share.key
  })

  let fn
  switch (share.key) {
    case 'Facebook':
      fn = shareFacebook
      $sensors.track($SENSORS_EVENT.clickToShareChannel, { shareChannel: 'Facebook', shareType })
      customEventFn(eventName.clickToShareChannel, {
        share_type: shareType,
        shareChannel: 'Facebook'
      })
      break
    case 'WhatsApp':
      fn = shareWhatsApp
      $sensors.track($SENSORS_EVENT.clickToShareChannel, { shareChannel: 'WhatsApp', shareType })
      customEventFn(eventName.clickToShareChannel, {
        share_type: shareType,
        shareChannel: 'WhatsApp'
      })
      break
    case 'SMS':
      fn = shareSMS
      $sensors.track($SENSORS_EVENT.clickToShareChannel, { shareChannel: 'SMS', shareType })
      customEventFn(eventName.clickToShareChannel, {
        share_type: shareType,
        shareChannel: 'SMS'
      })
      break
    case 'CopyLink':
      fn = shareCopyLink

      $sensors.track($SENSORS_EVENT.clickToShareChannel, { shareChannel: 'CopyLink', shareType })
      customEventFn(eventName.clickToShareChannel, {
        share_type: shareType,
        shareChannel: 'CopyLink'
      })
      break
  }

  if(useIsAndroid().value) {
    window.androidWebObject.clickItemShare(appShare)
  } else if(useIsFlutterApp().value) {
    window.flutter_inappwebview.callHandler('clickItemShare', appShare)
  } else {
    await fn(href, title)
  }
}
